import $ from 'jquery';

const $modal_inner = $('<div />', {'class': 'modal__inner'});
const $modal_close = $('<div />', {
  'class': 'modal__close',
  'html': Drupal.t('Close')
});
const $modal = $('<div />', {'class': 'modal'}).append([$modal_close, $modal_inner]);

const appendModal = ($link) => {
  $link.removeClass('loading');
  $modal.find('a').attr('target', '_blank');
  $('body').append($modal).addClass('modal-open');

  $modal_close.on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('modal-open');
    $modal.remove();
    $link.attr('aria-expanded', 'false');
  });
};

Drupal.behaviors.gutfeelingOpenModal = {
  attach: function (context) {
    once('gutfeelingOpenModal', '.open-modal', context).forEach((link) => {
      $(link).on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const isExpanded = $this.attr('aria-expanded');
        const url = $this.attr('href');
        const modalType = $this.data('modal-type');

        if (isExpanded === 'false') {
          $this.attr('aria-expanded', 'true');
          $this.addClass('loading');
        }
        else {
          $this.attr('aria-expanded', 'false');
        }

        if (modalType === 'image') {
          // TODO: take care of title and alt
          $modal_inner.empty();
          $modal_inner.append(`<div class="modal-image"><img src="${url}"></div>`);
          appendModal($this);
        }
        else {
          $modal_inner.empty();
          $modal_inner.load(url + " main", function (response) {
            if (response.length > 0) {
              appendModal($this);
            }
            else {
              // Open link in new window.
            }
          });
        }
      });
    });
  }
};
